import ActionManager from '../../ActionManager';

import AddCondition from './AddCondition';
ActionManager.register(AddCondition, ['stores:MainStore']);

import RemoveCondition from './RemoveCondition';
ActionManager.register(RemoveCondition, ['stores:MainStore']);

import UpdateCondition from './UpdateCondition';
ActionManager.register(UpdateCondition, ['stores:MainStore']);